/**************************************************************************************************/
/*   File: /src/app/shared/enums/dossier.status.enum.ts                                           */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The dossier state enum
 */
export enum DossierStatusEnum {
    /**
     * The created state
     */
    CREATED = 1,
    /**
     * The validation state
     */
    IN_VALIDATION = 2,
    /**
     * The not deliverable state
     */
    NOT_DELIVERABLE = 3,
    /**
     * The validated state
     */
    VALIDATED = 4,
    /**
     * The delivered state
     */
    DELIVERED = 5,
    /**
     * The in review state
     */
    IN_REVIEW = 6,
    /**
     * The deleted state
     */
    DELETED = 7,
    /**
     * The in use state
     */
    IN_USE = 8,
    /**
     * The not usable state
     */
    NOT_USABLE = 9
}